const NAMESPACE = "cancelSignaturesDialog";

const KEYS = {
    cancelExplanationTypeLabel: "cancelExplanationTypeLabel",
    cancelExplanationDetailLabelRequired: "cancelExplanationDetailLabelRequired",
    cancelExplanationDetailLabelAdditionalComments: "cancelExplanationDetailLabelAdditionalComments",
    cancelExplanationDetailOverrideMsg: "cancelExplanationDetailOverrideMsg",
    cancelDeterrentResending: "cancelDeterrentResending",
    cancelDeterrentCorrectingRecipient: "cancelDeterrentCorrectingRecipient",
    cancelAllDocsButtonLabel: "cancelAllDocsButtonLabel",
    cancelIncompleteDocsButtonLabel: "cancelIncompleteDocsButtonLabel",
    dontCancelButtonLabel: "dontCancelButtonLabel"
};

const MESSAGES = {
    [KEYS.cancelExplanationTypeLabel]: {
        value: "Please select a reason for canceling the eSignature request:",
        comment: "Label for radio input to choose top-level reason for canceling eSignature request"
    },
    [KEYS.cancelExplanationDetailLabelRequired]: {
        value: "Please provide some brief additional details (will be visible in an email to signatories):",
        comment: "Prompt for the user to explain why they are canceling signatures."
    },
    [KEYS.cancelExplanationDetailLabelAdditionalComments]: {
        value: "Any additional comments (will be visible in an email to signatories):",
        comment: "Validation error telling the user they need to provide a reason before canceling"
    },
    [KEYS.cancelExplanationDetailOverrideMsg]: {
        value: "Please provide a reason for canceling the eSignature request.",
        comment: "Validation error telling the user they need to provide a reason before canceling"
    },
    [KEYS.cancelDeterrentResending]: {
        value: 'Instead of canceling, try resending notifications for your existing eSignature request using the section above. Make sure all recipients check their spam folders for an email from DocuSign System. The eSignature request "From" field will show "Do Not Reply - PowerClerk Automated Notifications (donotreply-esign{\'@\'}cleanpower.com)." The email subject will include the text "eSignature Request" and the appropriate project number, if available.',
        comment:
            "Message to deter users from canceling in the case where they're just trying to resend an eSignature notification to the recipient"
    },
    [KEYS.cancelDeterrentCorrectingRecipient]: {
        value: "You can correct contact info for recipients who have not yet signed by updating the relevant contact info fields on the form, returning to this dialog, and using the Resend Notifications button above. When notifications are resent, any updated contact info for pending recipients will be applied to the in-flight eSignature request. However, note that updated contact information will not be reflected in the eSignature documents.",
        comment:
            "Message to deter users from canceling in the case when they're trying to correct recipient contact info"
    },
    [KEYS.cancelAllDocsButtonLabel]: {
        value: "Cancel All Documents",
        comment: "Label for button which when clicked disables all pending eSignatures"
    },
    [KEYS.cancelIncompleteDocsButtonLabel]: {
        value: "Cancel Incomplete Documents",
        comment: "Label for button which when clicked disables signatures which have not yet been completed."
    },
    [KEYS.dontCancelButtonLabel]: {
        value: "Don't Cancel",
        comment: "Label for button which dismisses the cancel dialog and does not cancel any signatures"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
